import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=10657d8c&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10657d8c')) {
      api.createRecord('10657d8c', component.options)
    } else {
      api.reload('10657d8c', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=10657d8c&", function () {
      api.rerender('10657d8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-21KmikSc8NCRT/JS/comp/ImgFallback.vue"
export default component.exports